/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable no-unused-vars */
import { Fragment, useEffect, useLayoutEffect, useMemo, useRef } from 'react';
import { StudentDashboardSidebar } from '../../components/StudentDashboardSidebar';
import StudentNavbar from '../../components/StudentNavbar';
import { useState } from 'react';
import polygon_arrow from '../../assets/images/Polygon-arrow.svg';
import { Link, useNavigate } from 'react-router-dom';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import moment from 'moment';
import 'react-circular-progressbar/dist/styles.css';
import ProgressBar from '@ramonak/react-progress-bar';
import { useDispatch, useSelector } from 'react-redux';
import 'react-circular-progressbar/dist/styles.css';
import book from '../../assets/images/classs-img.png';
import arrowRight from '../../assets/images/arrow-right.png';
import arrowLong from '../../assets/images/model/righArrowlong.svg';
import haye from '../../assets/images/model/haye.png';
import { allClasses, circleActivitites, forStudent } from '../../Store/api/activities';
import Calendars from '../../components/studentDashboard/Calendar';
import ProgessBarr from '../../components/ProgessBarr';
import { ActivityLoadingSkeleton } from '../../shared/ActivityLoadingSkeleton';
import { canAttempt, calculateLatePenalty } from '../../utils';
import ProgresMulti from '../../components/ProgresMulti';

const progrssBarStyleInner = {
  pathColor: `rgb(68, 32, 53)`,
  textColor: '#2e2e2d',
  trailColor: '#ded6eb',
  backgroundColor: '#C6B9DF',
  textSize: '12px',
  transition: 'stroke-dashoffset 0.5s ease 0s',
  transform: 'rotate(25turn)',
  transformOrigin: 'center center',
};
const progrssBarStyleOuter = {
  pathColor: `rgb(103, 0, 178)`,
  textColor: '#2e2e2d',
  trailColor: '#ded6eb',
  transition: 'stroke-dashoffset 0.5s ease 0s',
  transform: 'rotate(25turn)',
  transformOrigin: 'center center',
};

const StudentOverview = () => {
  const [sideBarEvent, setSideBarEvent] = useState('overview');
  const { activities, activitiesByAssignedDate } = useSelector(
    (state) => state.entities.student.book
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [activitiesList, setActivitiesList] = useState([]);
  /* This code for Circular progrss bar of Student activity */
  const [dueClasses, setDueClasses] = useState([]);
  const [gotoSubject, setGotoSubject] = useState(1);
  const [isLoading, setIsloading] = useState(false);
  const [isLoadings, setIsloadings] = useState(false);
  const [classSchedule, setClassSchedule] = useState();
  const [circleWeekActivity, setCircleWeekActivity] = useState([]);
  /* This for The Current Week Activity */

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const sevenDaysLater = new Date(today);
  sevenDaysLater.setDate(today.getDate() + 7);
  const fourteenDaysLater = new Date(today);
  fourteenDaysLater.setDate(today.getDate() + 14);

  const thisWeekActivities = circleWeekActivity
    .flatMap((book) => book.activities)
    .filter((activity) => {
      const assignedDate = new Date(activity.assignedDate);
      assignedDate.setHours(0, 0, 0, 0);
      const isWithinDateRange =
        assignedDate >= today &&
        assignedDate < sevenDaysLater &&
        activity.activityAnswers &&
        activity.activityAnswers.length;
      return isWithinDateRange;
    });

  const submittedActivities = thisWeekActivities.filter((activity) => {
    return (
      activity.activityAnswers &&
      activity.activityAnswers.length > 0 &&
      activity?.activityAnswers?.[0]?.activityStatus === 'Completed' &&
      activity.activityAnswers?.some((answer) => answer.answers && answer.answers.length > 0)
    );
  });

  const percentageSubmitted =
    thisWeekActivities.length > 0
      ? (submittedActivities.length / thisWeekActivities.length) * 100
      : 0;

  /* End...................... */

  /* This for Last Week Activities */
  let sevenDaysbefore = new Date();
  sevenDaysbefore.setDate(new Date().getDate() - 7);
  const lastWeekActivities = circleWeekActivity
    .flatMap((book) => book.activities)
    .filter((activity) => {
      const assignedDate = new Date(activity.assignedDate);
      assignedDate.setHours(0, 0, 0, 0);
      const isWithinDateRange =
        assignedDate < new Date().setHours(0, 0, 0, 0) &&
        assignedDate >= new Date(sevenDaysbefore).setHours(0, 0, 0, 0);
      return isWithinDateRange;
    });

  const submittedActivitiess = lastWeekActivities.filter((activity) => {
    return (
      activity.activityAnswers &&
      activity.activityAnswers.length > 0 &&
      activity?.activityAnswers?.[0]?.activityStatus === 'Completed' &&
      activity.activityAnswers.some((answer) => answer.answers && answer.answers.length > 0)
    );
  });

  const lastWeekSubmitted = (submittedActivitiess.length / lastWeekActivities.length) * 100;

  /* Activity Completed vs total numbers of activity*/
  const submittedActivitiesByCourse = (Array.isArray(dueClasses) ? dueClasses : []).map(
    (course) => {
      const submittedActivities =
        course.activities?.filter(
          (activity) =>
            activity.activityAnswers &&
            activity.activityAnswers.length > 0 &&
            activity?.activityAnswers?.filter((answer) => answer.isGraded).length
        ) || [];

      return {
        courseName: course.courseName,
        courseNumber: course.courseNumber,
        submittedActivitiesCount: submittedActivities.length,
      };
    }
  );

  const courseLength = submittedActivitiesByCourse.length;

  const totalActivities = Array.isArray(dueClasses)
    ? dueClasses.map((course) => (Array.isArray(course.activities) ? course.activities.length : 0))
    : [];

  // Calculate percentage function

  function calculatePercentage(numerator, denominator) {
    if (denominator === 0) {
      return 0;
    }
    return (numerator / denominator) * 100;
  }

  useLayoutEffect(() => {
    dispatch(
      forStudent({
        onSuccess: (res) => {
          const { data = [] } = res?.data || {};
          setActivitiesList(data);
        },
        onEnd: () => {
          setLoading(false);
        },
      })
    );
  }, []);

  useLayoutEffect(() => {
    setIsloading(true);
    dispatch(
      allClasses({
        onSuccess: (res) => {
          setDueClasses(res.data);
          setIsloading(false);
        },
        onError: () => {
          setIsloading(false);
        },
      })
    );
  }, []);

  useLayoutEffect(() => {
    setIsloadings(true);
    dispatch(
      circleActivitites({
        onSuccess: (res) => {
          setCircleWeekActivity(res.data.data);
          setIsloadings(false);
        },
        onError: (err) => {
          setIsloadings(false);
        },
      })
    );
  }, []);

  return (
    <div className='wrapper'>
      {/* <!-- Page Sidebar --> */}
      <StudentDashboardSidebar
        sideBarEvent={'overview'}
        setSideBarEvent={setSideBarEvent}
        setGotoSubject={setGotoSubject}
      />
      {/* <!-- Page Content Holder --> */}
      <div id='content'>
        <div className='content_dashborad_inner'>
          {/* <!-- navbar --> */}
          <StudentNavbar sideBarEvent={sideBarEvent} setSideBarEvent={setSideBarEvent} />
          <div className='main_section_content'>
            <div className='center_content center_content_h90vh ' style={{ overflow: 'visible' }}>
              {/* <!-- main content circular progress bar --> */}
              <ActivitythisWeek
                progrssBarStyleOuter={progrssBarStyleOuter}
                thisWeekActivities={thisWeekActivities}
                lastWeekActivities={lastWeekActivities}
                percentageSubmitted={percentageSubmitted}
                lastWeekSubmitted={lastWeekSubmitted}
                isLoadings={isLoadings}
                courseLength={courseLength}
                calculatePercentage={calculatePercentage}
              />
              <ActivitesDueNext
                loading={loading}
                activities={activitiesList}
                fourteenDaysLater={fourteenDaysLater}
                activitiesByAssignedDate={activitiesByAssignedDate}
              />
            </div>
            <div className='right_content right_content_main_overview bg_white'>
              {/* <!-- Top right sidebar calendar --> */}
              <CalanderActivity />
              {/* <!-- right sidebar assigned activities --> */}
              <AssignActivityRightside
                classSchedule={classSchedule}
                setClassSchedule={setClassSchedule}
                gotoSubject={gotoSubject}
                setGotoSubject={setGotoSubject}
                setSideBarEvent={setSideBarEvent}
                activities={activities}
                fourteenDaysLater={fourteenDaysLater}
                isLoading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
  function ActivitythisWeek({
    progrssBarStyleOuter,
    thisWeekActivities,
    lastWeekActivities,
    percentageSubmitted,
    lastWeekSubmitted,
    isLoadings,
    percentage,
    courseLength,
  }) {
    const [tooltipOuter, setTooltipOuter] = useState(false);
    const [tooltipInner, setTooltipInner] = useState(false);
    const [percentageGradedArray, setPercentageGradedArray] = useState([]);
    const [animatedLastWeek, setAnimatedLastWeek] = useState(0);
    const [animatedPercentage, setAnimatedPercentage] = useState(0);
    const [animatedCounts, setAnimatedCounts] = useState([]);
    const animatedLastWeekRef = useRef(0);
    const animatedPercentageRef = useRef(0);

    const computedPercentages = useMemo(() => {
      if (!Array.isArray(dueClasses) || dueClasses.length === 0) {
        return [];
      }
      // Return an array where each element corresponds to dueClasses[i]
      return dueClasses.map((cls) => {
        const activities = Array.isArray(cls.activities) ? cls.activities : [];
        let totalGradedMarks = 0;
        let totalActivities = activities.length;
        // According to original logic: each activity is worth 100 marks
        // and we only add graded marks if activity has graded answers.
        activities.forEach((activity) => {
          if (Array.isArray(activity.activityAnswers) && activity.activityAnswers.length > 0) {
            let activityGradedMarks = 0;
            // let activityPossibleMarks = 0; // not used if we stick to 100-per-activity logic
            activity.activityAnswers.forEach((answer) => {
              if (answer.isGraded) {
                // guard numeric fields
                const gradeValue = typeof answer.grade === 'number' ? answer.grade : 0;
                activityGradedMarks += gradeValue;
                // activityPossibleMarks += typeof answer.totalMarks === 'number' ? answer.totalMarks : 0;
              }
            });
            if (activityGradedMarks > 0) {
              totalGradedMarks += activityGradedMarks;
              // if using actual totalPossibleMarks, sum here. But original used totalActivities * 100.
            }
          }
        });
        const totalPossibleMarksForPercentage = totalActivities * 100;
        const percentage =
          totalPossibleMarksForPercentage > 0
            ? (totalGradedMarks / totalPossibleMarksForPercentage) * 100
            : 0;
        return Math.round(percentage);
      });
    }, [dueClasses]);

    useEffect(() => {
      setPercentageGradedArray(computedPercentages);
    }, [computedPercentages]);

    const handleMouseEnterOuter = () => {
      setTooltipOuter(true);
    };
    const handleMouseLeaveOuter = () => {
      setTooltipOuter(null);
    };
    const handleMouseEnterInner = () => {
      setTooltipInner(true);
    };
    const handleMouseLeaveInner = () => {
      setTooltipInner(null);
    };
    const progressBarfont = {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '400',
      display: 'flex', // Ensures alignment properties work
      alignItems: 'flex-start', // Aligns content to the start
      justifyContent: 'center', // Centers content along the main axis
    };

    useLayoutEffect(() => {
      const increment = setInterval(() => {
        if (animatedLastWeekRef.current < lastWeekSubmitted) {
          animatedLastWeekRef.current += 1;
          setAnimatedLastWeek(animatedLastWeekRef.current); // Update state only when needed
        }
        if (animatedPercentageRef.current < percentageSubmitted) {
          animatedPercentageRef.current += 1;
          setAnimatedPercentage(animatedPercentageRef.current); // Update state only when needed
        }

        // Stop animation when both targets are reached
        if (
          animatedLastWeekRef.current >= lastWeekSubmitted &&
          animatedPercentageRef.current >= percentageSubmitted
        ) {
          clearInterval(increment);
        }
      }, 10); // Adjust speed as needed

      return () => clearInterval(increment); // Cleanup interval
    }, [lastWeekSubmitted, percentageSubmitted]);

    // Animation for counts
    useLayoutEffect(() => {
      if (!submittedActivitiesByCourse || submittedActivitiesByCourse.length === 0) {
        return; // Exit early if there are no activities
      }

      // Initialize animated counts to zero for each activity
      const initialCounts = submittedActivitiesByCourse.map(() => 0);
      setAnimatedCounts(initialCounts);

      const interval = setInterval(() => {
        let allComplete = true;

        // Increment animated counts
        setAnimatedCounts((prevCounts) =>
          prevCounts.map((count, index) => {
            const targetCount = submittedActivitiesByCourse[index]?.submittedActivitiesCount || 0;
            if (count < targetCount) {
              allComplete = false; // Mark as incomplete if there are more counts to increment
              return count + 1; // Increment count
            }
            return count; // Keep count as is if the target is reached
          })
        );

        // Stop the interval if all counts are completed
        if (allComplete) {
          clearInterval(interval);
        }
      }, 100); // Adjust speed as needed

      return () => clearInterval(interval); // Clean up interval on unmount
    }, [submittedActivitiesByCourse]);

    const totalClasses = Array.isArray(dueClasses) ? dueClasses.length : 0;
    const isSingleClass = totalClasses <= 2;

    return (
      <div className='box_border activities_wrap border_shadow '>
        <div className='activities_wrap_inner cursor_default'>
          <div className='graph_wrap w_164'>
            {isLoadings ? (
              <h4 className='content-skeleton m-0'></h4>
            ) : (
              <div className='progress-bar-outer' style={{ position: 'relative' }}>
                <div
                  className='progress-bar-container'
                  onMouseEnter={() => handleMouseEnterOuter()}
                  onMouseLeave={handleMouseLeaveOuter}
                >
                  <CircularProgressbar
                    value={animatedPercentage}
                    styles={buildStyles(progrssBarStyleOuter)}
                  />
                </div>
                {tooltipOuter && (
                  <div className='calendar_tooltip_circle' style={{ top: '-47px' }}>
                    <div className='tooltip_text'>
                      <div className='fw-400' style={{ display: 'inline' }}>
                        This week - {thisWeekActivities.length}
                      </div>
                    </div>
                    <div
                      className='arrow-frame'
                      style={{
                        position: 'absolute',
                        bottom: '-9px',
                      }}
                    >
                      <img className='arrow_down' src={polygon_arrow} alt='polygon arrow' />
                    </div>
                  </div>
                )}
                <div
                  className='progress-bar-inner cursor_default'
                  style={{ marginTop: '-129px ', marginLeft: '30px ' }}
                  onMouseEnter={() => handleMouseEnterInner()}
                  onMouseLeave={handleMouseLeaveInner}
                >
                  <CircularProgressbar
                    className='custom-progress-bar'
                    value={animatedLastWeek}
                    text={`last week`}
                    styles={buildStyles(progrssBarStyleInner)}
                  />
                </div>
                {tooltipInner && (
                  <div className='calendar_tooltip_circle' style={{ top: '-18px' }}>
                    <div className='tooltip_text'>
                      <div className='fw-400' style={{ display: 'inline' }}>
                        {' '}
                        Last week - {lastWeekActivities.length}
                      </div>
                    </div>
                    <div
                      className='arrow-frame'
                      style={{
                        position: 'absolute',
                        bottom: '-9px',
                      }}
                    >
                      <img className='arrow_down' src={polygon_arrow} alt='polygon arrow' />
                    </div>
                  </div>
                )}
              </div>
            )}
            <h5 className='ft_14 fw_400 mt_16 mb-0'>activities this week</h5>{' '}
          </div>

          <div className='activities_completed w_164 cumulative-grade'>
            {isLoadings ? (
              <h4 className='content-skeleton m-0'></h4>
            ) : (
              <div className={`inner-grade `}>
                <div
                  className={`number_of_completed ${
                    courseLength === 2
                      ? `two-class`
                      : courseLength === 3
                      ? `three-class`
                      : courseLength === 4
                      ? `four-class`
                      : ``
                  }`}
                >
                  {submittedActivitiesByCourse &&
                    submittedActivitiesByCourse.map((course, index) => (
                      <div className='number_completed' key={index}>
                        <h5 className='ft_16 fw-600'>{course?.courseNumber?.slice(0, 7)}</h5>
                        <h5 className='ft_16 fw-400 mb-0'>
                          {course?.submittedActivitiesCount}/{totalActivities[index]}
                        </h5>
                      </div>
                    ))}
                </div>
              </div>
            )}
            <h5 className='ft_14  fw_400 mb-0'>activities completed</h5>{' '}
          </div>
          <div className='cumulative-grade '>
            {isLoadings ? (
              <h4 className='content-skeleton m-0 '></h4>
            ) : (
              <div
                className={`child-grade-progress ${
                  dueClasses.length === 1
                    ? 'single-class-parent'
                    : dueClasses.length === 2
                    ? 'double-class-parent'
                    : dueClasses.length === 3
                    ? 'triple-class-parent'
                    : 'fourth-class-parent'
                }`}
              >
                {Array.isArray(dueClasses) &&
                  dueClasses.map((course, index) => {
                    const { courseNumber } = course;
                    const totalClasses = dueClasses.length;
                    const isSingleClass = totalClasses <= 2;
                    const className = `${
                      totalClasses === 3
                        ? 'three-class-graph'
                        : totalClasses === 4
                        ? 'four-class-graph'
                        : ''
                    }`;

                    // Get the percentage for this class by index. Fallback to 0 if missing.
                    const percentageForThisClass =
                      Array.isArray(percentageGradedArray) && percentageGradedArray.length > index
                        ? percentageGradedArray[index]
                        : 0;

                    return (
                      <div key={course._id || index} className={className}>
                        {isSingleClass ? (
                          <ProgessBarr percentageGraded={percentageForThisClass} course={course} />
                        ) : (
                          <h5
                            className={`ft_16 fw-600 multi-class mb-0 ${
                              totalClasses > 2 ? 'mt-0' : ''
                            }`}
                          >
                            {/* Use <span> not <spam> */}
                            <span style={{ width: '34%' }}>
                              {courseNumber?.slice(0, 5) || ''}{' '}
                            </span>
                            <ProgresMulti
                              percentageGraded={percentageGradedArray[index]}
                              course={course}
                            />
                          </h5>
                        )}
                      </div>
                    );
                  })}
              </div>
            )}
            <h5 className='ft_14 fw_400 mb-0'>cumulative grade</h5>
          </div>
        </div>
      </div>
    );
  }

  function ActivitesDueNext({ loading, activities = [], fourteenDaysLater }) {
    const navigate = useNavigate();
    const flattenedActivities = activities.flatMap((e) => e.activities);

    const filterActivity = flattenedActivities.filter((e) => {
      // Ensure assignedDate exists before proceeding
      if (!e.assignedDate) return false;

      const assignedDate = new Date(e.assignedDate).setHours(0, 0, 0, 0);

      // Check if assignedDate is within the next 14 days
      // if (assignedDate < today || assignedDate >= fourteenDaysLater) {
      //   return false;
      // }
      if (assignedDate >= fourteenDaysLater) {
        return false;
      }
      // Ensure `activityAnswers` exists and is an array
      if (!Array.isArray(e.activityAnswers) || e.activityAnswers.length === 0) {
        return false;
      }

      // Check if at least one `activityAnswer` meets the required conditions
      return e.activityAnswers.some((ans) => {
        if (!Array.isArray(ans.answers)) return false;

        return (
          (!ans.isGraded && ans.answers.length === 0) || // Not graded and no answers
          (ans.activityStatus !== 'Completed' && ans.answers.length > 0) // In progress with answers
        );
      });
    });

    return (
      <div
        className='activities_due_next_over box_border mt_32 cursor_default position-relative'
        style={{
          padding: '0px 0px',
          border: 'none',
          boxShadow: 'none',
          // height: "50vh",
        }}
      >
        <div className='head_dash position-sticky top-0 bg-white '>
          <h5 className='ft_24 mb-0'>activities due next</h5>
          <p className='ft_12 mb-0 mt_10'>
            {filterActivity.length} activities due in next 14 days
          </p>
        </div>
        <div style={{ height: '84%', overflowY: 'scroll' }}>
          {loading &&
            !filterActivity.length > 0 &&
            [...new Array(4)].map((_, idx) => <ActivityLoadingSkeleton key={idx} />)}
          {!loading && filterActivity.length > 0 && (
            <>
              {filterActivity.slice(0, 5).map((activity, index) => {
                const filteredQuestions = activity?.questions?.filter(
                  (question) =>
                    question?.type && ['blanks', 'mcqs', 'truefalse'].includes(question.type)
                );
                const sectionIndex = activity?.chapter
                  ? activity?.chapter.sections.findIndex((e) => e._id === activity.section)
                  : -1;

                // Get the length of the filtered questions
                const autoGraded = filteredQuestions?.length || 0;

                // Safely filter questions with type "fr"
                const teacherGraded =
                  activity?.questions?.filter((question) => question?.type === 'fr').length || 0;

                return (
                  <div key={index} className='Definition_of_terms'>
                    <div className='img_Wrap_book'>
                      <img
                        src={
                          activity?.book?.coverImage ||
                          activity?.book?.activityBookCoverUrl ||
                          book
                        }
                        alt='book'
                      />
                    </div>
                    <div className='d-flex align-items-start justify-content-between w-100 px-3'>
                      <div className='book_text font_inter'>
                        <h6 className='ft_12 fw-700'>
                          {activity?.classInfo?.[0]?.courseName || 'Course Name'}
                        </h6>
                        <h5 className='ft_12 fw-500 mt_10 cursor'>
                          <u>{`Chapter ${activity?.chapter?.order || ''}${
                            activity?.section ? ` Section ${activity?.section?.order}` : ''
                          }`}</u>
                        </h5>
                        <h1 className='ft_18 fw-700 mt_10 mb-0'>{activity?.title}</h1>
                      </div>
                      {(moment(activity?.assignedDate).isBefore(moment(), 'D') ||
                        activity.activityAnswers?.[0]?.isSubmitted) && (
                        <h6 style={{ color: '#AE2604' }} className='ft_12 fw-700'>
                          {activity.activityAnswers?.[0]?.isSubmitted
                            ? activity.activityAnswers?.[0]?.penaltyCalculated || 0
                            : calculateLatePenalty(activity)}
                          % late penalty
                        </h6>
                      )}
                      <div className='book_text text-end font_inter'>
                        <h6
                          className='ft_12 fw-700'
                          style={{
                            ...(moment(activity?.assignedDate).isBefore(moment(), 'D') && {
                              color: '#AE2604',
                            }),
                          }}
                        >
                          Due date {moment(activity?.assignedDate).format('MM-DD-YYYY')}
                        </h6>
                        <h5 className='ft_12 fw-400 mt_10 mb-16'>{`${autoGraded} auto-graded, ${teacherGraded} teacher-graded`}</h5>
                        <h5 className='ft_12 fw-500 mb-0'>
                          {canAttempt(activity) && (
                            <a
                              href='#!'
                              className='ft_12 fw-500'
                              onClick={() => {
                                navigate(`/studentfocusedmode/${activity?._id}`);
                              }}
                            >
                              <u>
                                {activity?.activityAnswers &&
                                activity?.activityAnswers.some(
                                  (activityAns) =>
                                    activityAns.answers &&
                                    activityAns.answers.some(
                                      (answ) => answ.answers && answ.answers.length > 0
                                    )
                                )
                                  ? 'View'
                                  : 'Start'}
                              </u>
                            </a>
                          )}
                          <a
                            href='#!'
                            className='ft_12 fw-500'
                            onClick={() => {
                              navigate(`/studentdashboard/activities`);
                            }}
                          >
                            details
                            <img src={arrowRight} alt='arrow-right' />
                          </a>
                        </h5>
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          )}
          {!loading && !filterActivity.length > 0 && (
            <div style={{ overflowY: 'scroll', height: '100%' }}>
              <div className='d-flex align-items-center justify-content-center'>
                <span className='no-activity'>All caught up! </span>{' '}
                <img
                  style={{
                    width: '32px',
                    height: '32px',
                    paddingLeft: '4px',
                  }}
                  src={haye}
                  alt=''
                />
              </div>
              <div className='no-activity no-actv'>No activities due in next 14 days</div>
            </div>
          )}
        </div>
        <h5
          className='ft_12 fw-500 mb-0 text-end w-100 bottom-0 bg-white d-flex justify-content-between'
          style={{ position: 'absolute' }}
        >
          <span className='ft_12'>
            {filterActivity?.length > 0 && `+ ${filterActivity.length} activities`}
          </span>

          {filterActivity?.length > 0 && (
            <Link
              className='ft_12 text-decoration-none text-grey-500'
              to='/studentdashboard/activities'
            >
              <u className='tex_underline'>
                view all activities
                <img className='' src={arrowRight} alt='arrow-right' />
              </u>
            </Link>
          )}
        </h5>{' '}
      </div>
    );
  }
  function CalanderActivity() {
    return (
      <div className='calendar-skelton'>
        {isLoading ? (
          <h4 className='content-skeleton m-0'></h4>
        ) : (
          <div className='box_border_calendar clander_wrap_new_function border_shadow'>
            <Calendars />
          </div>
        )}
      </div>
    );
  }
  function AssignActivityRightside({ setGotoSubject, fourteenDaysLater, isLoading }) {
    const schedule = ['S', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'];
    const [tooltipDays, setTooltipDays] = useState({});
    const handleMouseEnter = (courseIndex, day) => {
      setTooltipDays((prevTooltipDays) => ({
        ...prevTooltipDays,
        [courseIndex]: day,
      }));
    };
    const handleMouseLeave = (courseIndex) => {
      setTooltipDays((prevTooltipDays) => ({
        ...prevTooltipDays,
        [courseIndex]: null,
      }));
    };

    return (
      <div className='class-skeleton'>
        {isLoading ? (
          <h4 className='content-skeleton  mt_32'></h4>
        ) : (
          <div className='assign_activity_right mt_32'>
            <Fragment>
              {Array.isArray(dueClasses) && dueClasses.length > 0 ? (
                dueClasses.map((course, index) => (
                  <div
                    key={index}
                    style={{
                      border: 'none',
                      marginBottom: index === dueClasses.length - 1 ? '0px' : '16px', // Add spacing below each class except the last one
                      paddingBottom: index === dueClasses.length - 1 ? '0px' : '16px', // Add padding for the bottom border line
                    }}
                    className='box_border date_Schedule cursor box_border-std'
                    onClick={() => {
                      setSideBarEvent('classes');
                      setGotoSubject(2);
                      navigate(`/studentdashboard/classes/class/${course._id}`);
                    }}
                  >
                    {dueClasses.length > 1 && index !== 0 && <div className='bottom-line'></div>}
                    {/* Main content */}
                    <h1 className='ft_16 mb-0'>
                      {course.courseName} <img className='' src={arrowLong} alt='arrow-right' />
                    </h1>

                    <div className='class-sesction mb-0 mt-1'>{`Section ${
                      course.sections?.[0]?.sectionNumber?.split?.('-')?.[0]
                    }`}</div>

                    <div className='intero mt-12 d-flex font_inter'>
                      <h1 className='ft_14 fw-600 txt_cap'>Instructor</h1>
                      <h6 className='ft_14 fw-400 txt_cap'>
                        {course.instructor.firstName + ' ' + course.instructor.lastName}
                      </h6>
                    </div>
                    <div className='intero font_inter'>
                      <h1 className='ft_14 fw-600 w-120 txt_cap mb-0 align-center'>Schedule</h1>
                      <div className='Create-custom-schedule mb-0'>
                        <ul className='custom-checkbox justify-content-between'>
                          {schedule.map((day, dayIndex) => (
                            <li key={dayIndex} className='option'>
                              <input type='checkbox' id={day} className='custom-checkbox' />
                              <label
                                htmlFor={day}
                                style={{
                                  backgroundColor: course.schedule
                                    .replace(/\s/g, '')
                                    .split(',')
                                    .includes(day)
                                    ? 'black'
                                    : '',
                                  color: course.schedule
                                    .replace(/\s/g, '')
                                    .split(',')
                                    .includes(day)
                                    ? 'white'
                                    : '',
                                }}
                                onMouseEnter={() => handleMouseEnter(index, day)}
                                onMouseLeave={() => handleMouseLeave(index)}
                              >
                                <span className='title_1'>{day}</span>
                                {course.schedule.replace(/\s/g, '').split(',').includes(day) &&
                                  tooltipDays[index] === day && (
                                    <div
                                      className={`calendar_tooltip_box arrow-center ${
                                        (day === 'Sa' || day === 'F') && 'sat-tooltips'
                                      }`}
                                      style={{
                                        top: '-49px',
                                        height: '39px',
                                      }}
                                    >
                                      <div className='tooltip_text'>
                                        <div className='fw-400' style={{ display: 'inline' }}>
                                          10:30am - 12:30pm
                                        </div>
                                      </div>
                                      <div
                                        className={`arrow-frame ${
                                          (day === 'Sa' || day === 'F') && `sat-arrow`
                                        }`}
                                        style={{
                                          position: 'absolute',
                                          bottom: '-8px',
                                        }}
                                      >
                                        <img
                                          className='arrow_down'
                                          src={polygon_arrow}
                                          alt='polygon arrow'
                                        />
                                      </div>
                                    </div>
                                  )}
                              </label>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className='intero d-flex font_inter mrt-8'>
                      <h1 className='ft_14 fw-600 txt_cap'>Activities</h1>
                      <h6 className='ft_14 fw-400 txt_smal'>
                        <b>
                          {
                            course.activities.filter(
                              (e) =>
                                new Date(e.assignedDate).setHours(0, 0, 0, 0) >=
                                  new Date().setHours(0, 0, 0, 0) &&
                                new Date(e.assignedDate).setHours(0, 0, 0, 0) <
                                  new Date(fourteenDaysLater).setHours(0, 0, 0, 0) &&
                                e.activityAnswers &&
                                e.activityAnswers.length > 0 &&
                                e.activityAnswers.some(
                                  (ans) =>
                                    (!ans.isGraded && !ans.answers.length) ||
                                    (ans.activityStatus === 'InProgress' && ans.answers.length > 0)
                                )
                            ).length
                          }
                        </b>{' '}
                        due in next 14 days
                      </h6>
                    </div>
                    <div className='intero d-flex font_inter '>
                      <h1 className='ft_14 fw-600 text-white txt_cap mb-0'>Activities</h1>
                      <h6 className='ft_14 fw-400 txt_smal mb-0'>
                        <b>
                          {
                            course.activities.filter((activity) => {
                              return (
                                activity.activityAnswers &&
                                activity.activityAnswers.some(
                                  (ans) =>
                                    !ans.isGraded &&
                                    ans.answers &&
                                    ans.answers.length > 0 &&
                                    ans.answers.length > 0 &&
                                    ans.activityStatus !== 'InProgress'
                                )
                              );
                            }).length
                          }
                        </b>{' '}
                        submitted
                      </h6>
                    </div>
                  </div>
                ))
              ) : (
                <div>No Due Classes</div>
              )}
            </Fragment>
          </div>
        )}
      </div>
    );
  }
};

export default StudentOverview;
